import generateEventPair from "../generateEventPair";

const {
  dispatcher: dispatchRailsRerender,
  responder: respondToRailsRerender
} = generateEventPair({
  eventName: "rails:rerender:js",
  eventHandler: event => event()
});

export { dispatchRailsRerender, respondToRailsRerender };
